import { Link } from "react-router-dom";
import { HeartHandshake, ChevronRight } from "lucide-react";

export const SupportBar = () => (
  <Link to="/community-unterstuetzen#cs-project-account" className="cherry-bar h-12 sm:h-10 flex items-center justify-center gap-2 sm:gap-3 px-3 text-white font-extrabold text-[12px] sm:text-sm tracking-wide" data-testid="support-bar">
    <HeartHandshake className="w-4 h-4 shrink-0 cherry-bar-beat" />
    <span className="min-w-0 leading-tight line-clamp-2" data-testid="support-bar-text">Die Community braucht eure Unterstützung</span>
    <span className="shrink-0 inline-flex items-center gap-0.5 h-7 pl-3 pr-2 rounded-full bg-white text-rose-700 text-[11px] sm:text-xs font-black shadow" data-testid="support-bar-more">Mehr erfahren <ChevronRight className="w-3.5 h-3.5" /></span>
  </Link>
);

export const SupportBarSpacer = () => <div className="h-12 sm:h-10" />;
